import { getChatActionSessionStorageValue, getTermsAndConditionsSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import { ChatIconsColors, ChatIcons, MessageType } from '../../conversational-search-types/conversational-search-types.type';
import type { ConversationalSearchActionMessages } from './action-messages';
import { ConversationalSearchActionMessagesBody } from './action-messages-body/action-messages-body';
import { h } from '@stencil/core';

export const renderMessage = (
  context: ConversationalSearchActionMessages,
  color: ChatIconsColors,
  iconName: ChatIcons,
  text: string,
  outroText = null,
  ctaText = null,
  isNewConversation = false,
  isMedaliaFallback = false,
  newConversationCta = null,
) => {
    return (
      <ConversationalSearchActionMessagesBody
        color={color}
        iconName={iconName}
        text={text}
        outroText={outroText}
        userQuery={context.query}
        conversationalSearchMedaliaFormId={isMedaliaFallback ? context.conversationalSearchMedaliaFormId : void 0}
        ctaText={ctaText}
        language={context.language}
        country={context.country}
        isNewConversation={isNewConversation}
        newConversationCta={newConversationCta}
      />
    );
};

export const renderCorrectMessage = (context: ConversationalSearchActionMessages) => {
    switch (context.messageType) {
    case MessageType.LIKED:
      return renderMessage(
        context,
        ChatIconsColors.SUCCESS_ICON_COLOR,
        ChatIcons.SUCCESS_ICON,
        context.labelProvider('conversational.search.action.like', 'Glad you liked the answer!'),
        null,
        context.labelProvider('conversational.search.feedback.share', 'Feedback'),
        null,
        true
      );
    case MessageType.DISLIKED:
      return renderMessage(
        context,
        ChatIconsColors.WARNING_ICON_COLOR,
        ChatIcons.WARNING_ICON,
        context.labelProvider('conversational.search.action.dislike', 'Why did you choose this rating?'),
        null,
        context.labelProvider('conversational.search.feedback.share', 'Feedback'),
        null,
        true
      );
    case MessageType.NEW_CONVERSATION:
      return renderMessage(
        context,
        ChatIconsColors.INFORMATION_ICON_COLOR,
        ChatIcons.INFORMATION_SOLID_ICON,
        context.labelProvider('conversational.search.action.message.new.conversation.intro', 'Any previous data will be lost'),
        null,
        context.labelProvider('conversational.search.conversation.confirmation.accept', 'Continue'),
        true,
        false,
        'Continue'
      );
    case MessageType.MEDALIA_FALLBACK:
      return renderMessage(
        context,
        ChatIconsColors.WARNING_ICON_COLOR,
        ChatIcons.WARNING_ICON,
        context.labelProvider('conversational.search.action.message.medalia.intro', 'Browser\'s pop-up blocker is preventing the modal from appearing.'),
        context.labelProvider('conversational.search.action.message.medalia.outro', 'Adjust your browser settings to allow pop-ups from context site.'),
        null,
        null,
        true
      );
    case MessageType.CONTEXT_CHANGED:
      return renderMessage(
        context,
        ChatIconsColors.INFORMATION_ICON_COLOR,
        ChatIcons.INFORMATION_SOLID_ICON,
        context.labelProvider('conversational.search.action.conversation.context.changed', 'Looks like the topic of the conversation has changed.'),
        null,
        context.labelProvider('conversational.search.action.conversation.context.changed.cta', 'Start a new topic.'),
        true,
        false,
        'Start a new topic'
      );
    case MessageType.CONTEXT_LOSTED:
      return renderMessage(
        context,
        ChatIconsColors.INFORMATION_ICON_COLOR,
        ChatIcons.INFORMATION_SOLID_ICON,
        context.labelProvider('conversational.search.action.conversation.context.losted', 'Oops! It looks like the previous conversation data was lost.')
      );
    default:
      return null;
    }
};

export const eventToMessageTypeMap = {
  'conversational-search:user-new-conversation': MessageType.NONE,
  'conversational-search:context-changed': MessageType.CONTEXT_CHANGED,
  'conversational-search:cta-action': () => {
      if (!getChatActionSessionStorageValue() && getTermsAndConditionsSessionStorageValue()) {
        return MessageType.CONTEXT_LOSTED;
      }
      return MessageType.NONE;
  },
  'conversational-search:user-new-conversation-trigger': MessageType.NEW_CONVERSATION,
  'conversational-search:thumbs': (e: CustomEvent) => e.detail?.variant === 'Like' ? MessageType.LIKED : MessageType.DISLIKED,
  'conversational-search:medalia-fallback': MessageType.MEDALIA_FALLBACK,
};